import { cn } from '@/lib/utils';

export function ChapterLabel({
  number,
  title,
  className,
}: {
  number: string;  // e.g. "01", "02", "03"
  title: string;   // e.g. "INFRASTRUCTURE", "THE PROBLEM"
  className?: string;
}) {
  return (
    <div
      className={cn(
        'inline-flex items-center gap-2.5 rounded-full border border-(--color-border) bg-(--color-bg-elevated) px-4 py-1.5',
        className,
      )}
    >
      <span aria-hidden="true" className="font-mono text-[11px] text-(--color-accent) leading-none">/</span>
      <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-(--color-text-muted) leading-none">
        {number}<span aria-hidden="true" className="mx-2 text-(--color-text-subtle) opacity-60">·</span>{title}
      </span>
    </div>
  );
}
